import { Button } from "@mui/material";

export default function OptionButton(props: {
  title: string;
  onClick: () => void;
}) {
  return (
    <Button
      style={{
        width: "200px",
        backgroundColor: "transparent",
        borderColor: "#2196f3",
      }}
      onClick={props.onClick}
    >
      {props.title}
    </Button>
  );
}
